module.exports = __webpack_public_path__ + "static/media/dailybookgreen-new.273878b5.svg";